import { render } from "./ResetPassword.vue?vue&type=template&id=8bad964e"
import script from "./ResetPassword.js?vue&type=script&lang=js"
export * from "./ResetPassword.js?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./ResetPassword.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Firshadck%2Fprojects%2Fsunrise-spa%2Fsrc%2Fpresentation%2Ffashion%2FUser%2FResetPassword%2FResetPassword.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/Users/irshadck/projects/sunrise-spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__